export function calculateDISCScores(answers) {
  const scores = { D: 0, I: 0, S: 0, C: 0 };
  
  answers.forEach(answer => {
    // Add points for "most" selection
    scores[answer.mostType] += 2;
    
    // Subtract points for "least" selection
    scores[answer.leastType] -= 1;
  });

  // Ensure no negative scores
  Object.keys(scores).forEach(key => {
    if (scores[key] < 0) scores[key] = 0;
  });

  return scores;
}

export function calculatePercentages(scores) {
  const total = Object.values(scores).reduce((sum, score) => sum + score, 0);
  
  if (total === 0) {
    return { D: 25, I: 25, S: 25, C: 25 };
  }

  const percentages = {};
  Object.keys(scores).forEach(key => {
    percentages[key] = Math.round((scores[key] / total) * 100);
  });

  // Ensure percentages add up to 100%
  const sum = Object.values(percentages).reduce((a, b) => a + b, 0);
  if (sum !== 100) {
    const diff = 100 - sum;
    const maxKey = Object.keys(percentages).reduce((a, b) => 
      percentages[a] > percentages[b] ? a : b
    );
    percentages[maxKey] += diff;
  }

  return percentages;
}

export function generateInterpretation(percentages) {
  const sortedTypes = Object.entries(percentages)
    .sort(([,a], [,b]) => b - a)
    .map(([type, value]) => ({ type, value }));

  const dominant = sortedTypes[0];
  const secondary = sortedTypes[1];

  const typeInterpretations = {
    D: {
      name: "Dominanz",
      high: "Sie sind eine natürliche Führungspersönlichkeit, die gerne Verantwortung übernimmt und Ergebnisse erzielt. Sie treffen schnelle Entscheidungen und sind sehr zielorientiert.",
      medium: "Sie zeigen Führungsqualitäten in bestimmten Situationen und können bei Bedarf Verantwortung übernehmen."
    },
    I: {
      name: "Initiative", 
      high: "Sie sind kommunikativ, enthusiastisch und arbeiten gerne mit anderen Menschen zusammen. Sie können andere begeistern und motivieren.",
      medium: "Sie sind gesellig und können gut mit anderen interagieren, bevorzugen aber nicht immer im Mittelpunkt zu stehen."
    },
    S: {
      name: "Stetigkeit",
      high: "Sie sind ein zuverlässiger Teamplayer, der Stabilität und Harmonie schätzt. Sie arbeiten geduldig und beständig an Ihren Aufgaben.",
      medium: "Sie schätzen ein ausgewogenes Arbeitsumfeld und können sowohl im Team als auch selbständig arbeiten."
    },
    C: {
      name: "Gewissenhaftigkeit",
      high: "Sie sind sehr detailorientiert, analytisch und qualitätsbewusst. Sie bevorzugen strukturierte Arbeitsweisen und hohe Standards.",
      medium: "Sie achten auf Details und Qualität, sind aber auch flexibel genug für weniger strukturierte Aufgaben."
    }
  };

  let interpretation = `Ihr dominanter Persönlichkeitstyp ist ${typeInterpretations[dominant.type].name} mit ${dominant.value}%. `;
  
  if (dominant.value >= 35) {
    interpretation += typeInterpretations[dominant.type].high;
  } else {
    interpretation += typeInterpretations[dominant.type].medium;
  }

  if (secondary.value >= 25) {
    interpretation += ` Ihr zweitstärkster Typ ist ${typeInterpretations[secondary.type].name} mit ${secondary.value}%, was bedeutet, dass Sie auch Eigenschaften aus diesem Bereich zeigen. `;
    interpretation += typeInterpretations[secondary.type].medium;
  }

  // Check for balanced profile
  const isBalanced = sortedTypes.every(({ value }) => value >= 20 && value <= 35);
  if (isBalanced) {
    interpretation += " Sie haben ein sehr ausgewogenes Persönlichkeitsprofil, was Ihnen Flexibilität in verschiedenen Situationen und Arbeitsumgebungen ermöglicht.";
  }

  return interpretation;
}